/**
 * @vuelto-surface
 * mobile: ok
 * desktop: n/a
 * strategy: inherit
 */
import React from 'react';
import { BarcodeScannerModal } from '../../shared/ui/BarcodeScannerModal';

type CatalogScannersProps = {
  barcodeAllowCamera: boolean;
  searchScannerVisible: boolean;
  formScannerVisible: boolean;
  bulkPriceScannerVisible: boolean;
  onSearchScannerClose: () => void;
  onFormScannerClose: () => void;
  onBulkPriceScannerClose: () => void;
  onSearchScan: (code: string) => void;
  onFormScan: (code: string) => void;
  onBulkPriceScan: (code: string) => void;
};

/** Los 3 BarcodeScannerModal del catálogo (search, form, bulk-price) en un solo componente. */
export function CatalogScanners({
  barcodeAllowCamera,
  searchScannerVisible,
  formScannerVisible,
  bulkPriceScannerVisible,
  onSearchScannerClose,
  onFormScannerClose,
  onBulkPriceScannerClose,
  onSearchScan,
  onFormScan,
  onBulkPriceScan,
}: CatalogScannersProps) {
  if (!barcodeAllowCamera) return null;

  return (
    <>
      <BarcodeScannerModal
        visible={searchScannerVisible}
        title="Buscar por código"
        subtitle="Leé el código para buscar el producto."
        onClose={onSearchScannerClose}
        onCodeScanned={onSearchScan}
      />
      <BarcodeScannerModal
        visible={formScannerVisible}
        title="Cargar código"
        subtitle="Leé el código para completar el campo."
        onClose={onFormScannerClose}
        onCodeScanned={onFormScan}
        requireConfirmation
      />
      <BarcodeScannerModal
        visible={bulkPriceScannerVisible}
        title="Filtrar precios por código"
        subtitle="Leé un código para ajustar solo ese producto."
        onClose={onBulkPriceScannerClose}
        onCodeScanned={onBulkPriceScan}
      />
    </>
  );
}
